import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  max-height: calc(100% - 90px);
  height: 100%;
  display: flex;
  background: #2c2c2c;
  justify-content: center;
`;
